<div class="filter-modal-container">
  <div class="filter-header">{{contractorListEnum.FilterLabel}}</div>
  <div class="filter-container">
    <form [formGroup]="filterForm" class="filter-form">
      <ng-container *ngIf="openForm">
        <emerald-dropdown
          [label]="'Vendor'"
          [outlined]="true"
          [isValid]="true"
          formControlName="vendor"
          [options]="vendorOptions"
          [id]="'vendor_select'"
          [preSelectedLabel]="'label'"
          [preSelectedValue]="'value'"
        ></emerald-dropdown>
        
        <emerald-dropdown
          [label]="'Status'"
          [outlined]="true"
          [isValid]="true"
          formControlName="status"
          [options]="statusOptions"
          [id]="'status_select'"
          [preSelectedLabel]="'label'"
          [preSelectedValue]="'value'"
        ></emerald-dropdown>
        
        <emerald-dropdown
          [label]="'Regular'"
          [outlined]="true"
          [isValid]="true"
          formControlName="regular"
          [options]="regularOptions"
          [id]="'regular_select'"
          [preSelectedLabel]="'label'"
          [preSelectedValue]="'value'"
        ></emerald-dropdown>
        
        <emerald-dropdown
          [label]="'Location'"
          [outlined]="true"
          [isValid]="true"
          formControlName="location"
          [options]="locationOptions"
          [id]="'location_select'"
          [preSelectedLabel]="'label'"
          [preSelectedValue]="'value'"
        ></emerald-dropdown>
        
        <emerald-dropdown
          [label]="'Reporting Manager'"
          [outlined]="true"
          [isValid]="true"
          [showFilter]="true"
          formControlName="reportingManager"
          [options]="reportingManagerOptions"
          [id]="'manager_select'"
          [preSelectedLabel]="'label'"
          [preSelectedValue]="'value'"
        ></emerald-dropdown>

        <emerald-dropdown
          [label]="'DOJ'"
          [outlined]="true"
          [isValid]="true"
          formControlName="month"
          [options]="monthOptions"
          [id]="'month_select'"
          [preSelectedLabel]="'label'"
          [preSelectedValue]="'value'"
          (onSelectionChange)="onMonthSelect($event)"
        ></emerald-dropdown>
      </ng-container>

      <ng-container actions>
        <div class="button-container">
          <emerald-button
            [label]="'Reset'"
            [size]="'Small'"
            [type]="'Secondary'"
            (onClick)="reset()"
          ></emerald-button>
          <emerald-button
            [label]="'Apply'"
            [type]="'Primary'"
            (onClick)="opened = false; apply()"
          ></emerald-button>
        </div>
      </ng-container>
    </form>
  </div>
</div>